import pinFilledIconUrl from '@/assets/user-apps/pin-filled.svg'
import pinOutlineIconUrl from '@/assets/user-apps/pin-outline.svg'
import { cn } from '@/lib/cn'

export function PinFilledIcon({ className }: { className?: string }) {
  return (
    <img alt="" aria-hidden className={cn('size-3.5 shrink-0', className)} src={pinFilledIconUrl} />
  )
}

export function PinOutlineIcon({ className }: { className?: string }) {
  return (
    <img
      alt=""
      aria-hidden
      className={cn('size-3.5 shrink-0', className)}
      src={pinOutlineIconUrl}
    />
  )
}

export function ConversationPinIcon({
  className,
  pinned,
}: {
  className?: string
  pinned: boolean
}) {
  return pinned ? <PinFilledIcon className={className} /> : <PinOutlineIcon className={className} />
}
